export const companiesCompanyIdCustomRolesCustomRoleId = "/companies/:company_id/custom_roles/custom_role/:id";
